// extracted by mini-css-extract-plugin
export default {"wrapper":"XaXZNs8WlFDbxQq_f5nm"};